export default __webpack_public_path__ + "281bf97129d4000cb1363b8c566fff32.png";